import React, { useEffect, useReducer, useState } from 'react';
import styled from 'styled-components';
import { VALIDATION_STATES } from '../../utils/constants';
import ComposedSelectField from '../ComposedField/ComposedSelectField';
import { MONTH_OPTIONS, DAY_OPTIONS, YEAR_OPTIONS, verifiedDaysInMonthOptions } from '../../utils/registrationFormDropdownOptions';
import { parseDate, parseDateToNumberStrings } from '../../utils/dates';
import { breakpoints, GridContainer } from '@parchment/atoms';
import { isValueAnOption, monthValidator, yearValidator } from './validation';
const INITIAL_VALIDATION_STATE = {
  month: VALIDATION_STATES.neutral,
  day: VALIDATION_STATES.neutral,
  year: VALIDATION_STATES.neutral
};
export default function DateOfBirthGrid(_ref) {
  let {
    dateOfBirth = '',
    value = dateOfBirth || '',
    onChange,
    onValidate,
    validators = []
  } = _ref;
  const propsDate = parseDateToNumberStrings(value);
  const [validation, setValidation] = useState(INITIAL_VALIDATION_STATE);
  const [month, setMonth] = useReducer(coalesceToEmptyStringReducer, propsDate.month);
  const [day, setDay] = useReducer(coalesceToEmptyStringReducer, propsDate.day);
  const [year, setYear] = useReducer(coalesceToEmptyStringReducer, propsDate.year);
  useEffect(() => {
    setMonth(propsDate.month);
    setDay(propsDate.day);
    setYear(propsDate.year);
  }, [value]);
  useEffect(() => {
    const states = Object.values(validation).map(val => val).filter(val => val !== VALIDATION_STATES.success);
    onValidate && onValidate(states.length ? VALIDATION_STATES.error : VALIDATION_STATES.success);
  }, [validation]);
  useEffect(() => {
    const dateOfBirthStr = parseDate([year, month, day].join('-'), ['yyyy-M-d']).toISODate();
    onChange && dateOfBirthStr !== value && onChange(dateOfBirthStr);
  }, [month, day, year]);
  return /*#__PURE__*/React.createElement(DateOfBirthFormGrid, {
    "data-testid": "date-of-birth-grid",
    id: "date-of-birth-grid"
  }, /*#__PURE__*/React.createElement(GridContainer, {
    className: "date-of-birth-grid"
  }, /*#__PURE__*/React.createElement(ComposedSelectField, {
    id: "month-select",
    className: "month-field",
    name: "month",
    label: "Month Of Birth",
    value: month,
    options: MONTH_OPTIONS,
    onChange: setMonth,
    onValidate: value => setValidation(current => ({
      ...current,
      month: value
    })),
    validators: [...validators, monthValidator],
    required: true
  }), /*#__PURE__*/React.createElement(ComposedSelectField, {
    id: "day-select",
    className: "day-field",
    name: "day",
    label: "Day Of Birth",
    value: day,
    options: DAY_OPTIONS,
    onChange: setDay,
    onValidate: value => setValidation(current => ({
      ...current,
      day: value
    })),
    validators: [...validators, {
      message: 'Please enter a valid Day of Birth',
      callback: value => isValueAnOption(value, verifiedDaysInMonthOptions(month, year))
    }],
    required: true
  }), /*#__PURE__*/React.createElement(ComposedSelectField, {
    id: "year-select",
    className: "year-field",
    name: "year",
    label: "Year Of Birth",
    value: year,
    options: YEAR_OPTIONS,
    onChange: setYear,
    onValidate: value => setValidation(current => ({
      ...current,
      year: value
    })),
    validators: [...validators, yearValidator],
    required: true
  })));
}
function coalesceToEmptyStringReducer(state, value) {
  return value || state || '';
}
const DateOfBirthFormGrid = /*#__PURE__*/styled.div.withConfig({
  displayName: "DateOfBirthGrid__DateOfBirthFormGrid",
  componentId: "sc-1adk648-0"
})([".month-field,.day-field,.year-field{width:100%;@media (min-width:", "){width:33%;}}"], breakpoints.mediumMin);